import { EpimsBaseEntityDto } from './epim-base.dto';
export class AddressBookDto extends EpimsBaseEntityDto {
  AddressBookId: string;
  TitleId: string;
  Email: string;
  Name: string;
  PhoneNo: string;
  Address: string;
  StateId: string;
  LgaId: string;
  CommunityId: string;
  BankId: string;
  AccountName: string;
  AccountNo: string;
  Remarks: string;
  VendorId: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  LandTitle_LandTitleId: string;
}
